// extracted by mini-css-extract-plugin
module.exports = {"grid":"style_grid__28h6A","column":"style_column__3nUhc","row":"style_row__3npBG"};